/** Разметка, за которой при чтении текста стоит граница абзаца или строки */
const BLOCK_LEVEL_SELECTOR = 'p, div, li, tr, blockquote, pre, h1, h2, h3, h4, h5, h6';

/** Разбирает разметку в документ — общий первый шаг для всех переводов её в текст. */
const parseRichText = (html: string): HTMLElement =>
  new DOMParser().parseFromString(`<div>${html}</div>`, 'text/html').body;

/**
 * Текст комментария без разметки в одну строку — то, по чему сравниваются версии.
 * Границы абзацев не сохраняются: для сравнения важны сами слова.
 */
export const richTextToPlain = (html: string): string => parseRichText(html).textContent ?? '';

/**
 * Текст комментария для чтения: разметка снята, но границы абзацев и строк сохранены переносами.
 * Без них конец одного абзаца слипается с началом следующего в одно слово.
 */
export const richTextToReadableText = (html: string): string => {
  const body = parseRichText(html);
  for (const lineBreak of body.querySelectorAll('br')) lineBreak.replaceWith('\n');
  for (const block of body.querySelectorAll(BLOCK_LEVEL_SELECTOR)) block.append('\n');
  // Пустой абзац между текстом даёт двойной перенос — больше него отступ уже не читается
  return (body.textContent ?? '').replace(/\n{3,}/g, '\n\n').trim();
};
